import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

import { H2Component } from '~/app/shared/components/elements/h2/h2.component';
import { ChoiceButtonsComponent } from '~/app/shared/components/forms/formElements/choice-buttons/choice-buttons.component';
import { ChoiceButtonComponent } from '~/app/shared/components/forms/formElements/choice-button/choice-button.component';

@Component({
    selector: 'eb-help-option-selector',
    templateUrl: './help-option-selector.component.html',
    styleUrl: './help-option-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FormsModule,
        TranslocoPipe,
        H2Component,
        ChoiceButtonsComponent,
        ChoiceButtonComponent,
    ],
})
export class HelpOptionSelectorComponent {
    public hasCalendly = input<boolean>(false);
    public hasFormContacts = input<boolean>(false);

    public selectAppointment = output<void>();
    public selectForms = output<void>();

    public onOptionSelect(optionId: string | null): void {
        if (optionId === 'appointment') {
            this.selectAppointment.emit();
        } else if (optionId === 'forms') {
            this.selectForms.emit();
        }
    }
}
